<template>
    <div class="search-panel__filter-result">
        <div v-if="windowWidth < 960" class="grid__container">
            <a :href="link.href" :class="['search-panel__result-button', {'is-disabled': link.disabled}]">
                <span v-if="!link.disabled">
                    Смотреть <span class="link__no-br">{{ link.text }}</span>
                </span>
                <span v-else>{{ link.text }}</span>
            </a>
        </div>
        <a v-else :href="link.href" :class="['link', 'link_theme_white', {'is-disabled': link.disabled}]">
            <span v-if="!link.disabled" class="link__inner">
                <span class="search-panel__result-word">Смотреть </span>
                <span class="link__no-br">{{ link.text }}</span>
            </span>
            <span v-else class="link__inner">{{ link.text }}</span>
            <LinkIconArrow />
        </a>
    </div>
</template>

<script>
import LinkIconArrow from '../media/link-icon-arrow.vue';

export default {
    props: ['link', 'windowWidth'],

    components: {
        LinkIconArrow
    }
};
</script>
